/* */ 
"use strict";
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
require('core-js/modules/es7.symbol.async-iterator');
require('core-js/modules/es6.symbol');
require('core-js/modules/es6.object.keys');
require('core-js/modules/web.dom.iterable');
require('core-js/modules/es6.array.iterator');
require('core-js/modules/es6.object.to-string');
require('core-js/modules/es6.string.iterator');
require('core-js/modules/es6.weak-map');
Object.defineProperty(exports, "__esModule", {value: true});
var _exportNames = {
  sdcActions: true,
  on: true,
  onAll: true,
  once: true,
  off: true,
  trigger: true,
  EVENTS: true,
  tryParse: true,
  tryStringify: true
};
Object.defineProperty(exports, "on", {
  enumerable: true,
  get: function get() {
    return _events.on;
  }
});
Object.defineProperty(exports, "onAll", {
  enumerable: true,
  get: function get() {
    return _events.onAll;
  }
});
Object.defineProperty(exports, "once", {
  enumerable: true,
  get: function get() {
    return _events.once;
  }
});
Object.defineProperty(exports, "off", {
  enumerable: true,
  get: function get() {
    return _events.off;
  }
});
Object.defineProperty(exports, "trigger", {
  enumerable: true,
  get: function get() {
    return _events.trigger;
  }
});
Object.defineProperty(exports, "EVENTS", {
  enumerable: true,
  get: function get() {
    return _events.EVENTS;
  }
});
Object.defineProperty(exports, "tryParse", {
  enumerable: true,
  get: function get() {
    return _parser.tryParse;
  }
});
Object.defineProperty(exports, "tryStringify", {
  enumerable: true,
  get: function get() {
    return _parser.tryStringify;
  }
});
exports.sdcActions = void 0;
var calls = _interopRequireWildcard(require('./calls'));
var _events = require('./events');
var _parser = require('./parser');
var _callbacks = require('./callbacks');
Object.keys(_callbacks).forEach(function(key) {
  if (key === "default" || key === "__esModule")
    return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key))
    return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _callbacks[key];
    }
  });
});
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function")
    return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {default: obj};
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var sdcActions = calls;
exports.sdcActions = sdcActions;
